import { IconButton } from '@mui/material';
import ReceiptIcon from '@mui/icons-material/ReceiptTwoTone';
import { queueModal } from '@components/Modals/modalSlice';
import { useAppDispatch } from '@reduxStore';

import styles from './ApplicationLink.module.css';

interface DeliveryReceiptLinkProps {
  className?: string;
  legId: number;
}

/**
 * Component for rendering a Delivery Receipt link.
 */
export default function DeliveryReceiptLink(props: DeliveryReceiptLinkProps) {
  const appDispatch = useAppDispatch();

  const handleBtnClick = () => {
    appDispatch(
      queueModal({
        Component: 'viewDispatchEventsModal',
        Props: {
          legId: props.legId,
          eventType: 'Pickup/Delivery Receipt Sent'
        }
      })
    );
  };

  return (
    <IconButton
      className={styles['icon-btn']}
      onClick={handleBtnClick}>
      <ReceiptIcon fontSize='inherit' />
    </IconButton>
  );
}
